import { Typography } from '@mui/material';
import { CustomButton, CustomTextField, HorizontalForm } from '../../../../../common/components';
import { formatCurrency } from '../../utils/formatters';

const PayIntentForm = ({
  installmentsToPay,
  cuotaPura,
  onInstallmentsChange,
  onCuotaPuraChange,
  onSubmit,
  isSubmitting,
  totalFromForm,
  pendingInstallments,
}) => {
  const numericInstallments = Number(installmentsToPay);
  const exceedsPending =
    pendingInstallments &&
    !Number.isNaN(numericInstallments) &&
    numericInstallments > pendingInstallments;
  return (
    <HorizontalForm withBorder={false} sx={{ mb: 2 }}>
      <CustomTextField
        label="Cuotas diferidas a pagar"
        type="number"
        size="medium"
        value={installmentsToPay}
        onChange={(e) => onInstallmentsChange(e.target.value)}
        inputProps={{
          min: 0,
          step: 0.01,
          max: pendingInstallments || undefined,
        }}
        error={Boolean(exceedsPending)}
        helperText={
          exceedsPending
            ? 'No puede exceder las cuotas pendientes.'
            : pendingInstallments
              ? `Pendiente: ${pendingInstallments.toFixed(2)} cuotas`
              : ''
        }
        sx={{ maxWidth: 250, mr: 1.5, mt: 0 }}
      />
      <CustomTextField
        label="Cuota pura"
        type="number"
        size="medium"
        value={cuotaPura}
        onChange={(e) => onCuotaPuraChange(e.target.value)}
        inputProps={{ min: 0, step: 0.01 }}
        sx={{ maxWidth: 250, mr: 1.5, mt: 0 }}
      />
      <CustomButton
        onClick={onSubmit}
        variant="base"
        disabled={isSubmitting || !installmentsToPay || !cuotaPura || exceedsPending}
        sx={{ mr: 1.5 }}
      >
        Registrar
      </CustomButton>
      <Typography
        variant="body2"
        sx={{
          alignSelf: 'center',
          fontSize: '1rem',
        }}
      >
        Total estimado: {formatCurrency(totalFromForm)}
      </Typography>
    </HorizontalForm>
  );
};

export default PayIntentForm;
